import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["nl", "fr", "de", "en"],
    fallbackLng: 'en',
    // debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${baseURL}/locales/{{lng}}/{{ns}}`,
    },
  });

export default i18n;